<template>
  <div :class="wrapperClasses">
    <RemarkTypeSelectorButton
      :selected="noteSelected"
      :label="noteLabel"
      :description="noteDescription"
      icon="fa fa-comment"
      data-testid="remark-type__remark"
      @click="setNote"
    />
    <RemarkTypeSelectorButton
      :selected="todoSelected"
      :label="todoLabel"
      :description="todoDescription"
      icon="fa fa-bolt"
      data-testid="remark-type__todo"
      @click="setTodo"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import RemarkTypeSelectorButton from './remark-type-selector-button.vue'

const type = defineModel()

const noteLabel = I18n.t('communication.remark_form.note_label')
const todoLabel = I18n.t('communication.remark_form.todo_label')

const noteDescription = I18n.t('communication.remark_form.note_description')
const todoDescription = I18n.t('communication.remark_form.todo_description')

const noteSelected = computed(() => type.value === 'note')
const todoSelected = computed(() => type.value === 'todo')

const wrapperClasses =
  'tw-bg-sf-neutral-lighter-1 tw-rounded-md tw-flex tw-items-center tw-justify-between tw-p-1 tw-mb-4'

function setNote() {
  type.value = 'note'
}

function setTodo() {
  type.value = 'todo'
}
</script>
